import React from 'react'
import './index.less'

const clsPrefix = 'c-laboratory-item-card'
const LaboratoryItemCard: React.FC<{
  title: string[],
  imgUrl?: string,
}> = ({
  title = [],
  imgUrl = '',
}) => {
  return (
    <div className={clsPrefix} >
      {/*<img src={imgUrl} className={`${clsPrefix}__image`} alt='' />*/}
      <div className={`${clsPrefix}__content`}>
          <div className={`${clsPrefix}__labImage`}>
              <img src={imgUrl}/>
          </div>
          <div className={`${clsPrefix}__title`}>
              {
                  title && title.map((text,index) => (
                      <p key={index}>{text}</p>
                  ))
              }
          </div>
      </div>
    </div>
  )
}

export { LaboratoryItemCard }
